/* import __COLOCATED_TEMPLATE__ from './conversation-header.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const ConversationHeader = templateOnlyComponent<Signature>();
export default ConversationHeader;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Onboarding::ConversationHeader': typeof ConversationHeader;
    'inbox2/onboarding/conversation-header': typeof ConversationHeader;
  }
}
